module.exports = __webpack_public_path__ + "static/media/steel.b936c479.jpg";